import SetupHikEnabledAgreementSmsModal from './setup-hik-enabled-agreement-sms-modal.vue'
export default SetupHikEnabledAgreementSmsModal
